<template>

    <article id="browsercheck" v-if="warn_user">
        <h2>
            Din internet-browser vil muligvis ikke fungere
        </h2>
        <p>
            Vi ser, at din internet-browser ikke understøtter alle de teknologier, som bruges på dette site.<br> 
            Nogle funktioner vil muligvis ikke fungere for dig.
        </p>
        <p>
            Vi anbefaler, at du opdaterer din browser eller installerer en nyere browser, <a href="https://www.mozilla.org/da/firefox/new/" title="Hent og installér Firefox">f.eks. Firefox.</a>
        </p>
        <p>
            <button @click="setGotIt()" id="accept">Jeg forstår</button>
        </p>
    </article>

</template>


<script>

    export default {
        data: function() {
            return {
                warn_user: false
            }
        },
        methods: {
            setGotIt: function() {
                localStorage.setItem('booking_app_old_browser', 'understood')
                this.warn_user = false
            },
            checkBrowser: function() {
                if (!localStorage.getItem('booking_app_old_browser')) {
                    const user_agent = navigator.userAgent,
                        regx = /MSIE|Trident/i
                    if (user_agent.search(regx) !== -1) {
                        this.warn_user = true
                    }
                }
            }
        },
        created: function() {
            this.checkBrowser()
        }
    }

</script>


<style lang="scss">

    @import "../../styles/vars.scss";

    #browsercheck {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        padding: 4rem 2rem;
        background-color: $grey10;
        color: $grey0;
        z-index: 1000;
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: center;

        & > * {
            width: 100%;
            max-width: $wide;
            margin: .5rem 1rem;
            flex: 0 1 auto;
        }
        h1 {
            font-size: 1.25rem;
        }
        button {
            margin: 0 .5rem 0 0;
            border-radius: .25rem;
        }
        a,
        a:link,
        a:visited {
            color: $grey4;
        }
    }

    @media screen and (min-width: $wide) {

        #browsercheck {
            box-shadow: 0 -.5rem 0 hsla(0,0%,0%,.3);
            top: auto;
            height: auto;     
        }        

    }

</style>
